import type { Node, Schema } from '@milkdown/kit/prose/model';

import { VIDEO_NODE_NAME } from '../../nodes/video';
import { createCellImageNode } from '../tableCellImage';

const IMAGE_BLOCK_NODE_NAME = 'image-block';

export function createMediaNode(
  schema: Schema,
  kind: 'image' | 'video',
  src: string,
  file: File,
  asInlineImage: boolean,
): Node | null {
  if (kind === 'image') {
    if (asInlineImage) {
      return createCellImageNode(schema, src, file.name, '');
    }
    const nodeType = schema.nodes[IMAGE_BLOCK_NODE_NAME];

    return nodeType ? nodeType.create({ src, caption: file.name, ratio: 1 }) : null;
  }

  const nodeType = schema.nodes[VIDEO_NODE_NAME];

  return nodeType ? nodeType.create({ src, title: file.name, width: 640, height: 360 }) : null;
}
